export default __webpack_public_path__ + "static/media/simple-link-icon.7912ccc9.svg";